import { lazy, Suspense, useEffect } from "react";
import { motion } from "motion/react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import SacredGeometry from "./components/SacredGeometry";
import Shell from "./components/Shell";

const BiblePage = lazy(() => import("./pages/BiblePage"));
const AtlasPage = lazy(() => import("./pages/AtlasPage"));
const VriylPage = lazy(() => import("./pages/VriylPage"));
const CodexPage = lazy(() => import("./pages/CodexPage"));
const TalePage = lazy(() => import("./pages/TalePage"));

function RouteReset() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function LoadingPage() {
  const { pathname } = useLocation();
  const shape = pathname.startsWith("/atlas") || pathname.startsWith("/explorar")
    ? "triangle"
    : pathname.startsWith("/codex")
      ? "pentagon"
      : pathname.startsWith("/vriyl")
        ? "square"
        : "square";

  return (
    <motion.div
      className={`route-loading route-loading-${shape}`}
      initial={{ opacity: 0, filter: "blur(8px)", scale: 0.985 }}
      animate={{ opacity: 1, filter: "blur(0px)", scale: 1 }}
      exit={{ opacity: 0, filter: "blur(8px)", scale: 1.015 }}
      transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
    >
      <SacredGeometry shape={shape} className="route-loading-geometry" />
      <span>A abrir o arquivo…</span>
    </motion.div>
  );
}

export default function App() {
  const location = useLocation();
  return (
    <Shell>
      <RouteReset />
      <ErrorBoundary resetKey={location.pathname}>
        <Suspense fallback={<LoadingPage />}>
          {/* Sem AnimatePresence mode="wait": o exit não concluía e prendia a troca de
              rota (BiblePage nunca desmontava). Cada página anima a própria entrada
              (PageFrame/motion); a troca por rota remonta de imediato. */}
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<BiblePage />} />
            <Route path="/index.html" element={<BiblePage />} />
            <Route path="/contos" element={<TalePage />} />
            <Route path="/contos-de-um-velho-rabugento" element={<TalePage />} />
            <Route path="/atlas" element={<AtlasPage />} />
            <Route path="/explorar.html" element={<AtlasPage />} />
            <Route path="/vriyl" element={<VriylPage />} />
            <Route path="/vriyl.html" element={<VriylPage />} />
            <Route path="/codex" element={<CodexPage />} />
            <Route path="/codex.html" element={<CodexPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </ErrorBoundary>
    </Shell>
  );
}
